import {combineReducers} from 'redux'
import auth from 'auth/store/reducers'
import eCommerceApp from 'main/content/store/reducers'
import fuse from './fuse'

const rootReducer = combineReducers({
  auth,
  fuse,
  eCommerceApp,
})

export default rootReducer



// WEBPACK FOOTER //
// ./src/store/reducers/index.js